export const AppSettings = {
  BasicAuthBase64String: 'YXkkYTUlJmp3cnRtbmg7bGFzamRmOTg3ODc0NTY6YWJjQDk4Nzk3aGprYXMkJmFzZCgqJCUxMjM0',
  graphAPIhost: 'https://graph.microsoft.com',
  graphAPIVersion: 'v1.0'
};
export const clearLocalStorage = () => {
  caches.open('v1').then((cache) => {
    cache.keys().then((keys) => {
      keys.forEach((request) => {
        cache.delete(request);
      });
    });
  });
};

export const HttpStatusCode = {
  NoContent: 204,
  Accepted: 202,
  Ok: 200,
  NotFound: 404,
};

export const fetchWebAPIResponseJsonWithBasicAuth = apiUrl => {
  return new Promise((resolve, reject) => {
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Frame-Options': 'Deny',
        Authorization: `Basic ${AppSettings.BasicAuthBase64String}`,
      },
    })
      .then(response => {
        resolve(response.json());
      })
      .catch(error => {
        if (error) {
          if (error.indexOf('401') > -1) {
            window.location.reload(true);
          }
        }
        reject(error);
      });
  });
};

export const fetchWebAPIResponseJson = (idToken, apiUrl, tenantId = null) => {
  return new Promise((resolve, reject) => {
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Frame-Options': 'Deny',
        Authorization: `Bearer ${idToken}`,
      },
    })
      .then(response => {
        if (response.status === 401) {
          window.location.reload(true);
        }
        else if (response.status !== 500) {
          resolve(response.json());
        } else {
          resolve(response);
        }
      })
      .catch(error => {
          if (error) {
          logError(tenantId, error);
          if (error.indexOf('401') > -1) {
            window.location.reload(true);
          }
        }
        reject(error);
      });
  });
};

export const getPhoto = (apiUrl, accessToken, version = AppSettings.graphAPIVersion, tenantId = null) => {
  return new Promise((resolve, reject) => {
    let url = apiUrl.replace(/^\/+/, '');
    if (apiUrl.indexOf(AppSettings.graphAPIhost) === -1) {
      url = `${AppSettings.graphAPIhost}/${version}/${apiUrl}`;
    }
    try {
      fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Frame-Options': 'Deny',
        },
      })
        .then(response => {
          if (response.status === HttpStatusCode.Ok) {
            response
              .blob()
              .then(responseJSON => {
                const blobUrl = window.URL.createObjectURL(responseJSON);
                resolve(blobUrl);
              })
              .catch((error) => {
                logError(tenantId, error);
                resolve(null);
              });
          }
          else if (response.status === HttpStatusCode.NotFound) {
            resolve(null);
          }
          else {
            response.json().then(responseJSON => {
              reject(responseJSON);
            });
          }
        })
        .catch(error => {
          logError(tenantId, error);
          if (error && typeof (error) !== 'object') {
            if (error.indexOf('401') > -1) {
              window.location.reload(true);
            }
          }
          resolve(null);
        });
    } catch (error) {
      logError(tenantId, error);
    }
  });
};

export const postWebAPIResponseWithJSON = (token, apiUrl, data, tenantId = null) => {
  return new Promise((resolve, reject) => {
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Frame-Options': 'Deny',
      },
      body: data,
    })
      .then(response => {
        if (response.status === 401) {
          window.location.reload(true);
        }
        else {
          resolve(response.json());
        }
      })
      .catch(error => {
        logError(tenantId, error);
        if (error) {
          if (error.indexOf('401') > -1) {
            window.location.reload(true);
          }
        }
        reject(error);
      });
  });
};

export const fetchGraphAPIResponse = (accessToken, apiUrl, version = AppSettings.graphAPIVersion, tenantId = null) => {
  return new Promise((resolve, reject) => {
    let url = apiUrl.replace(/^\/+/, '');
    if (apiUrl.indexOf(AppSettings.graphAPIhost) === -1) {
      url = `${AppSettings.graphAPIhost}/${version}/${apiUrl}`;
    }
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'X-Frame-Options': 'Deny'
      },
    })
      .then(response => {
        if (response.status === HttpStatusCode.Ok) {
          response
            .json()
            .then(responseJSON => {
              if (responseJSON.error !== null && responseJSON.error !== undefined) {
                if (responseJSON.error.code && (responseJSON.error.code === 'InvalidAuthenticationToken' || responseJSON.error.message.indexOf('has expired') > -1)) {
                  window.location.reload(true);
                }
                logError(tenantId, responseJSON.error);
                reject(responseJSON.error);
              } else {
                resolve(responseJSON);
              }
            })
            .catch(error => {              
              logError(tenantId, error);
              reject(error);
            });
        } else if (response.status === HttpStatusCode.NotFound) {
          resolve(null);
        }
      })
      .catch(error => {  
        logError(tenantId, error);
        reject(error);
      });
  });
};

export const fetchPOSTGraphAPI = (accessToken, apiUrl, body, version = AppSettings.graphAPIVersion, tenantId = null) => {
  return new Promise((resolve, reject) => {
    let url = apiUrl.replace(/^\/+/, '');
    if (apiUrl.indexOf(AppSettings.graphAPIhost) === -1) {
      url = `${AppSettings.graphAPIhost}/${version}/${apiUrl}`;
    }
    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'X-Frame-Options': 'Deny'
      },
      body,
    })
      .then(response => {
        if (response.status === HttpStatusCode.NoContent || response.status === HttpStatusCode.Accepted) {
          resolve(response);
        } else {
          response
            .json()
            .then(responseJSON => {
              resolve(responseJSON);
            })
            .catch(error => {
              logError(tenantId, error);
              reject(error);
            });
        }
      })
      .catch(error => {
        logError(tenantId, error);
        reject(error);
      });
  });
};

export const fetchPATCHGraphAPI = (accessToken, apiUrl, body, version = AppSettings.graphAPIVersion, tenantId = null) => {
  return new Promise((resolve, reject) => {
    let url = apiUrl.replace(/^\/+/, '');
    if (apiUrl.indexOf(AppSettings.graphAPIhost) === -1) {
      url = `${AppSettings.graphAPIhost}/${version}/${apiUrl}`;
    }
    fetch(url, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'X-Frame-Options': 'Deny'
      },
      body,
    })
      .then(response => {
        if (response.status === HttpStatusCode.NoContent || response.status === HttpStatusCode.Accepted) {
          resolve(response);
        } else {
          response
            .json()
            .then(responseJSON => {
              resolve(responseJSON);
            })
            .catch(error => {
              logError(tenantId, error);
              reject(error);
            });
        }
      })
      .catch(error => {
        logError(tenantId, error);
        reject(error);
      });
  });
};

export const fetchPUTGraphAPI = (accessToken, apiUrl, body, contentType, version = AppSettings.graphAPIVersion, tenantId = null) => {
  return new Promise((resolve, reject) => {
    let url = apiUrl.replace(/^\/+/, '');
    if (apiUrl.indexOf(AppSettings.graphAPIhost) === -1) {
      url = `${AppSettings.graphAPIhost}/${version}/${apiUrl}`;
    }
    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType != '' ? contentType : 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'X-Frame-Options': 'Deny'
      },
      body,
    })
      .then(response => {
        if (response.status === HttpStatusCode.NoContent || response.status === HttpStatusCode.Accepted) {
          resolve(response);
        } else {
          response
            .json()
            .then(responseJSON => {
              resolve(responseJSON);
            })
            .catch(error => {
              logError(tenantId, error);
              reject(error);
            });
        }
      })
      .catch(error => {
        logError(tenantId, error);
        reject(error);
      });
  });
};

export const deleteResponse = (accessToken, apiUrl, version = AppSettings.graphAPIVersion, tenantId = null) => {
  return new Promise((resolve, reject) => {
    let url = apiUrl.replace(/^\/+/, '');
    if (apiUrl.indexOf(AppSettings.graphAPIhost) === -1) {
      url = `${AppSettings.graphAPIhost}/${version}/${apiUrl}`;
    }
    fetch(url, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'X-Frame-Options': 'Deny'
      },
    })
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      logError(tenantId, error);
      reject(error);
    });
  });
};


const logError = async (tenantId, error) => {
  let body = {
    tenantId: tenantId,
    message: error
  }
  const response = await Helper.postWebAPIResponseWithJSON('', `api/Log/LogInfo`, body)
  if (response) {
    return true;
  }
}